import type { SectionSchemaType } from '@/features/customization/schema';
import type { FieldType } from '@/shared/types';

/** Maps prescription panel section ids to visit timeline field types. */
export const PRESCRIPTION_SECTION_TO_TIMELINE_FIELD: Partial<Record<string, FieldType>> = {
  consultationDetails: 'consultationDetails',
  chiefComplaint: 'complaint',
  hopi: 'hopi',
  familyHistory: 'familyHistory',
  personalHistory: 'personalHistory',
  generalExamination: 'generalExaminations',
  systemicExamination: 'systemicExaminations',
  medicationHistory: 'medicationHistory',
  medicationExamination: 'medicationExaminations',
  diagnosis: 'diagnosis',
  medication: 'drugOrder',
  investigation: 'investigation',
  radiology: 'radiology',
  immunization: 'immunization',
  psychometricAssessment: 'psychometricAssessment',
  advice: 'advice',
};

/** Custom sections share one field type, so a row is identified by type and concept together. */
export interface TimelineRowKey {
  type: FieldType;
  conceptKey: string;
}

export const sortTimelineRowKeys = (rowKeys: TimelineRowKey[], sections?: SectionSchemaType[]): TimelineRowKey[] => {
  if (!sections?.length) return rowKeys;

  const ordered: TimelineRowKey[] = [];
  const seen = new Set<TimelineRowKey>();

  const sortedSections = [...sections].sort(
    (a, b) => (a.preferences?.order ?? Number.MAX_SAFE_INTEGER) - (b.preferences?.order ?? Number.MAX_SAFE_INTEGER),
  );

  for (const section of sortedSections) {
    const fieldType = PRESCRIPTION_SECTION_TO_TIMELINE_FIELD[section.id];
    if (!fieldType) continue;

    for (const rowKey of rowKeys) {
      if (rowKey.type === fieldType && !seen.has(rowKey)) {
        ordered.push(rowKey);
        seen.add(rowKey);
      }
    }
  }

  for (const rowKey of rowKeys) {
    if (!seen.has(rowKey)) ordered.push(rowKey);
  }

  return ordered;
};
